<claim-empty-state *ngIf="this.sharedConfig.schedulesActive.length <= 0"></claim-empty-state>

<claim-on-active-policy *ngIf="this.sharedConfig.schedulesActive.length > 0"></claim-on-active-policy>

